import * as React from 'react'

export const SVG_External_Link = (props: { color: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <g fill={props.color} fillRule="nonzero">
                <g>
                    <g>
                        <path
                            d="M7.184 5.259h2.75c.079 0 .142.063.142.142v8.292c0 .078-.063.142-.142.142H1.642c-.079 0-.142-.064-.142-.142v-2.8c0-.277-.224-.5-.5-.5s-.5.223-.5.5v2.8c0 .63.511 1.142 1.142 1.142h8.292c.63 0 1.142-.511 1.142-1.142V5.401c0-.631-.511-1.142-1.142-1.142h-2.75c-.276 0-.5.224-.5.5s.224.5.5.5z"
                            transform="translate(-280 -17) translate(280 17) translate(.167 .588) rotate(90 5.788 9.547)"
                        />
                        <path
                            d="M4.557 7.075h8.407c.276 0 .5-.224.5-.5 0-.277-.224-.5-.5-.5H4.557c-.276 0-.5.223-.5.5 0 .276.224.5.5.5z"
                            transform="translate(-280 -17) translate(280 17) translate(.167 .588) rotate(-45 8.76 6.575)"
                        />
                        <path
                            d="M8.59 2.52l2.475 2.475c.195.195.511.195.707 0 .195-.195.195-.512 0-.707L9.297 1.813c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707z"
                            transform="translate(-280 -17) translate(280 17) translate(.167 .588) rotate(-45 10.18 3.404)"
                        />
                        <path
                            d="M11.047 6.745l2.475-2.475c.195-.195.195-.512 0-.707-.196-.195-.512-.195-.707 0L10.34 6.038c-.195.195-.195.512 0 .707.195.195.512.195.707 0z"
                            transform="translate(-280 -17) translate(280 17) translate(.167 .588) scale(1 -1) rotate(-45 -.512 0)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
